import React from 'react'

function SpotlightPlaceholder () {
  return (
    <div className="spotlight-placeholder" />
  )
}

export default SpotlightPlaceholder
